import { z } from 'zod';

export const DEPENDENCY_TYPE = {
  UNSPECIFIED: 'UNSPECIFIED',
  SUCCESSOR: 'SUCCESSOR',
  PREDECESSOR: 'PREDECESSOR',
} as const;

export const dependencyTypeSchema = z.enum(DEPENDENCY_TYPE);

export const itemDependencySchema = z.object({
  type: dependencyTypeSchema,
  itemId: z.number().int().positive(),
});

export type DependencyType = z.infer<typeof dependencyTypeSchema>;
export type ItemDependencyDTO = z.infer<typeof itemDependencySchema>;
